import { styled } from '@clickcease/cc-client-components-lib'
import * as Collapsible from '@radix-ui/react-collapsible'

export const CollapsibleTrigger = styled(Collapsible.Trigger, {
  all: 'unset',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  marginBottom: '$6',
})

export const BundlePlanBoxStyled = styled('div', {
  position: 'sticky',
  top: '0px',
  display: 'flex',
  flexDirection: 'column',
  width: '256px',
  padding: '32px',
  height: '459px',
  background: 'rgba(136, 179, 231, 0.1)',
  margin: '$9 0px 0px 60px',
  borderRadius: '10px',

  '@bp1': {
    position: 'fixed',
    bottom: '0px',
    zIndex: '999',
    width: 'calc(100% -  24px)',
    maxWidth: 'calc(100% -  $12)',
    top: 'unset',
    height: 'auto',
    padding: '16px 12px',
    margin: '0',
    borderTop: '1px solid $lightGray',
    background: 'rgba(243, 247, 253, 1)',
    left: '0px',
    borderRadius: '0px',
  },

  '@laptop': {
    width: '200px',
  },
})

export const BundlePlanBoxTitle = styled('div', {
  fontWeight: '$b',
  fontSize: '$hxl',

  '@bp1': {
    fontSize: '$h2',
    fontWeight: '$sb',
  },
})

export const BundlePlanBoxProduct = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$lg',
  marginBottom: '$8',

  '@bp1': {
    flexDirection: 'row',
  },
  '@laptop': {
    marginBottom: '$4',
  },
})

export const BundlePlanBoxProductTitle = styled('div', {
  fontWeight: '$sb',
  '@bp1': {
    fontWeight: '$r',
  },
})

export const BundlePlanBoxProductRow = styled('div', {
  marginTop: '$2',
  '@bp1': {
    margin: '0px 0px 0px $2',
  },
})

export const BundlePlanBoxSeparator = styled('div', {
  width: '100%',
  height: '1px',
  background: '$lightGray',
  margin: '$2 0px $10 0px',

  '@bp1': {
    margin: '$2 0px $4 0px',
  },

  '@laptop': {
    marginBottom: '$4',
  },
})

export const BundlePlanBoxDiscount = styled('div', {
  margin: '$2 0px $4 0px',
  fontWeight: '$r',
  fontSize: '$lg',
  '@bp1': {
    right: '$4',
    color: '$primaryColor',
    fontWeight: '$sb',
  },
})

export const BundlePlanBoxBilledAnnually = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',

  '@bp1': {
    marginBottom: '$10',
  },
})

export const BundlePlanCustomPricing = styled('div', {
  fontWeight: '$sb',
  fontSize: '$h1',
  margin: '26px 0px 23px 0px',
})

export const TrialNote = styled('span', {
  fontWeight: '$r',
  fontSize: '$md',
  marginTop: '$5',
})
